import { List, useTable, ShowButton, CreateButton } from '@refinedev/antd';
import { Table, Tag } from 'antd';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { BidiText, MonoCode, formatDateBidi } from '@lebinatikra/rtl-utils';

interface OrgRow {
  id: string;
  community_id: string;
  name: string;
  slug: string;
  subscription_tier: string;
  created_at: string;
}

export function OrganizationList() {
  const { t } = useTranslation();
  const { communityId } = useParams();
  const { tableProps } = useTable<OrgRow>({
    resource: 'organizations',
    pagination: { pageSize: 25 },
    meta: { parentId: communityId },
  });

  return (
    <List headerButtons={() => <CreateButton>{t('actions.create_org')}</CreateButton>}>
      <Table {...tableProps} rowKey="id">
        <Table.Column<OrgRow>
          dataIndex="name"
          title={t('common.name')}
          render={(v) => (
            // rtl-utils:bidi-wrapped
            <BidiText>{v}</BidiText>
          )}
        />
        <Table.Column<OrgRow>
          dataIndex="slug"
          title={t('fields.slug')}
          render={(v) => (
            // rtl-utils:bidi-wrapped
            <MonoCode>{v}</MonoCode>
          )}
        />
        <Table.Column<OrgRow>
          dataIndex="subscription_tier"
          title={t('fields.subscription_tier')}
          render={(v) => <Tag>{v}</Tag>}
        />
        <Table.Column<OrgRow>
          dataIndex="created_at"
          title={t('common.created_at')}
          render={(v) => formatDateBidi(v)}
        />
        <Table.Column<OrgRow>
          title={t('common.actions')}
          render={(_, record) => (
            <ShowButton hideText size="small" recordItemId={record.id} />
          )}
        />
      </Table>
    </List>
  );
}
